let __USE_JAVASCRIPT_CONSOLE_LOG = document.getElementById('USE_JAVASCRIPT_CONSOLE_LOG').value;

/*----------------------------------------------------------------------*/
/* Document ready                                                       */
/*----------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', function () {
    if (__USE_JAVASCRIPT_CONSOLE_LOG === 'true') {
        console.log('called : (CmsResponsiveMenu)');
    }

    new CmsResponsiveMenu().init();
});

/*----------------------------------------------------------------------*/
/* CmsResponsiveMenu                                                    */
/*----------------------------------------------------------------------*/
function CmsResponsiveMenu() {
    this.selectElement = (element) => document.querySelector(element);
    this.selectElementAll = (element) => document.querySelectorAll(element);
}

/*----------------------------------------------------------------------*/
/* PROTOTYPE : init                                                     */
/*----------------------------------------------------------------------*/
CmsResponsiveMenu.prototype.init = function () {
    /*----------------------------------------------------------------------
        Fixes transition flickers on page refresh hack.

        NOTE: the duration time comes from the themea_menu table in the database and
              looking for the active theme record for the loaded page.
    ----------------------------------------------------------------------*/
    const menu_theme_transition_duration = document.getElementById('menu_theme_transition_duration').value / 3;

    setTimeout(() => {
        const ul_Objects = document.querySelectorAll('ul');

        ul_Objects.forEach((element) => {
            if (element.classList.contains('cms-sub-menu') === true) {
                element.classList.toggle('no-transition-duration');
            }
        });

        const a_Objects = document.querySelectorAll('a');

        a_Objects.forEach((element) => {
            if (element.classList.contains('no-transition-duration') === true) {
                element.classList.toggle('no-transition-duration');
            }
        });

        const i_Objects = document.querySelectorAll('i');

        i_Objects.forEach((element) => {
            if (element.classList.contains('no-transition-duration') === true) {
                element.classList.toggle('no-transition-duration');
            }
        });
    }, menu_theme_transition_duration);

    /*----------------------------------------------------------------------
        Mobile Menu - Navigation
    ----------------------------------------------------------------------*/
    if (this.selectElement('.cms-menu-icons') !== null) {
        this.selectElement('.cms-menu-icons').addEventListener('click', () => {
            this.selectElement('html').classList.toggle('cms-stop-scrollbar');
            this.selectElement('body').classList.toggle('cms-stop-scrollbar');
            this.selectElement('.cms-resposive-menu-mobile-backdrop').classList.toggle('active');
            this.selectElement('nav').classList.toggle('active');
        });
    }

    /*----------------------------------------------------------------------
        Mobile Menu - Sub menu click activation ie: slide up down.
    ----------------------------------------------------------------------*/
    const oMobileMenu = this.selectElementAll('.cms-menu-header');

    if (oMobileMenu !== null) {
        oMobileMenu.forEach((element) => {
            element.addEventListener('click', (e) => {
                let oObject = '';
                e.stopPropagation();
                // Href
                if (e.target.attributes.href !== undefined) {
                    oObject = e.target.parentElement;

                    // Sub Menu Chevron
                } else {
                    oObject = e.target.parentElement.parentElement;
                }

                // Only toggle class if the menu item is a heading.
                if (oObject !== '') {
                    if (oObject.classList.contains('cms-menu-header')) {
                        e.preventDefault();
                        oObject.classList.toggle('active');
                    }
                }
            });
        });
    }
};
